import { render, staticRenderFns } from "./StepIdentification.vue?vue&type=template&id=4e1c8f99&scoped=true&"
import script from "./StepIdentification.vue?vue&type=script&lang=js&"
export * from "./StepIdentification.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StepIdentification.vue?vue&type=style&index=1&id=4e1c8f99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c8f99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1c8f99')) {
      api.createRecord('4e1c8f99', component.options)
    } else {
      api.reload('4e1c8f99', component.options)
    }
    module.hot.accept("./StepIdentification.vue?vue&type=template&id=4e1c8f99&scoped=true&", function () {
      api.rerender('4e1c8f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61808000-5/external/StepIdentification.vue"
export default component.exports